import useLanguageBadge from 'hooks/useLanguageBadge'
import React, { FunctionComponent } from 'react'
import { LanguageBadge } from 'types/Badge'
import Badge from './Badge'

interface ILanguageBadgeProps {
  language: LanguageBadge
}

const LanguageBadge: FunctionComponent<ILanguageBadgeProps> = ({ language }): JSX.Element => {
  const { languageName, languageClassnames } = useLanguageBadge(language)

  return <Badge className={languageClassnames}>{languageName}</Badge>
}

export default LanguageBadge
